import React, {useState} from 'react'
import axiosInstance from '../../http/axios';

import Toast from '../../toast';

import { TextField, Button, Fab, IconButton } from '@mui/material';
import AddRounded from '@mui/icons-material/AddRounded';
import ArrowBackRounded from '@mui/icons-material/ArrowBackRounded';

import Header from '../header/Header';

import DropdownMenu from '../dropdown_menu/DropdownMenu';

const CreateService = ()=>{

     const [isSending, setIsSending] = useState(false);
     const [data, setData] = useState({
          name: '',
          servicesTime: "10:00 AM, 10:30 AM, 11:00 AM, 11:30 AM, 12:00 PM, 12:30 PM, 1:00 PM, 1:30 PM, 2:00 PM, 2:30 PM, 3:00 PM, 3:30 PM, 4:00 PM, 4:30 PM, 5:00 PM, 5:30 PM, 6:00 PM, 6:30 PM, 7:00 PM, 7:30 PM, 8:00 PM, 8:30 PM, 9:00 PM, 9:30 PM, 10:00 PM",
          serviceCharge: '',
          commission: '',
          file: '',
     })
     const selectionItems = ["None"];

     const navigate = (a)=> {
          if(typeof a == 'string'){
               window.location.href = a;
          }
          else if(typeof a == 'number'){
               window.history.go(a);
          }
     };

     const onChange = (event)=>{
          const { value, name } = event.target;
          setData(pVal => {
               if(name != 'file'){
                    return {
                         ...pVal,
                         [name]: value
                    };
               }
               else{
                    return {
                         ...pVal,
                         file: event.target.files[0]
                    };
               }
          });
     }

     const validate = () => {
          if(!data.servicesTime){
               Toast.error("Please enter service time");
               return false;
          }
          else if(!data.name){
               Toast.error("Please enter service name");
               return false;
          }
          else if(!data.serviceCharge){
               Toast.error("Please enter service charge");
               return false;
          }
          else if(!data.commission){
               Toast.error("Please enter commission");
               return false;
          }
          if(!data.file){
               Toast.error("Please upload banner image");
               return false;
          }
          return true;
     }

     const onSubmit = async ()=>{

          if(!validate()) return;

          setIsSending(true)
          try {
               const rBody = new FormData();
               Object.keys(data).forEach(key => rBody.append(key, data[key]));
               const res = await axiosInstance.post("admin/services", rBody, 
                    {
                         headers: { "Content-Type": "multipart/form-data" }
                    }
               )
               Toast.success('Success');
               setIsSending(false);
               navigate('/admin-services')
          } catch (error) {
               console.log(error);
               setIsSending(false)
               Toast.error('Failed');
          }
     }

     return(
          <>
               <Header/>
               <div className="d-flex justify-content-between">
                    <div style={{height: '80px'}} className='d-flex align-items-center'>
                         <IconButton onClick={()=>navigate(-1)}><ArrowBackRounded/></IconButton>
                         <h5  style={{marginLeft: '10px', height: '100%', marginTop: '5px'}} className='d-flex align-items-center'>Create Services</h5>
                    </div>
               </div>
               <div className="d-flex justify-content-center" style={{height:'100vh', marginTop: '50px'}}>
                    <div className='notification_container d-flex align-items-center flex-column'>
                         {/* <h2 className='text-center' style={{marginTop: '50px'}}>Banner</h2> */}
                         <div style={{ width: '100%', marginLeft: '35px'}}>
                              <div className='notification-import-image-root d-flex justify-content-center align-items-center' style={{marginTop: '20px'}}>
                                   { data.file ? <img style={{height: '100%', width: '100%'}} src={URL.createObjectURL(data.file)}/> : <div> <AddRounded /> Image </div> }
                              </div>
                              <label htmlFor="upload-photo" style={{marginTop: '10px'}}>
                                   <input name="file" onChange={onChange} style={{ display: 'none' }} id="upload-photo" type="file" itemType='image/*' />
                                   <Fab color="primary" size="small" component="span" aria-label="add" variant="extended">
                                        <AddRounded /> Upload
                                   </Fab>
                              </label>
                         </div>
                         <TextField name='name' value={data.name} onChange={onChange} style={{width: '90%', marginTop: '20px', color: 'red'}} fullWidth label="Name" type="text" />
                         <TextField name='servicesTime' value={data.servicesTime} onChange={onChange} style={{width: '90%', marginTop: '20px', color: 'red'}} fullWidth multiline label="Service time" type="text" />
                         <TextField name='serviceCharge' value={data.serviceCharge} onChange={onChange} style={{width: '90%', marginTop: '20px', color: 'red'}} fullWidth label="Charge (INR)" type="number" />
                         <TextField name='commission' value={data.commission} onChange={onChange} style={{width: '90%', marginTop: '20px', color: 'red'}} fullWidth label="Commission (INR)" type="number" />
                         
                         <button onClick={onSubmit} style={{width: '90%', marginTop: '30px', cursor: isSending ? "progress" : 'pointer'}} className="__btn">Create</button>
                    </div>
               </div>
          </>
     );
}

export default CreateService;